import React, { useState } from "react";
import { AuthorizedLayout } from "../Layouts/AuthorizedLayout";
import BoxHeader from "../../Components/Box/BoxHeader";
import SelectedUserMenu from "../../Assets/images/menu-icons/manage_accounts_selected.png";
import { AntTab, AntTabs } from "../../Components/Tab/AntTab";
import PlayerFilter from "./PlayerFilter";
import RejectedPlayer from "./RejectedPlayer";
import AcceptedPlayer from "./AcceptedPlayer";
import { Dayjs } from "dayjs";

export default function PlayerManagement() {
  const [activeTab, setActiveTab] = useState(0);
  const [selectedPlayer, setSelectedPlayer] = useState<any>(null);
  const [selectedUser, setSelectedUser] = useState<any>(null);
  const [startDate, setStartDate] = useState<Dayjs | null>(null);
  const [endDate, setEndDate] = useState<Dayjs | null>(null);

  return (
    <AuthorizedLayout>
      <BoxHeader
        dashboard_name="Player Management"
        image={SelectedUserMenu}
        button_show={false}
      >
        <AntTabs
          value={activeTab}
          onChange={(_, newValue) => setActiveTab(newValue)}
        >
          <AntTab label="Rejected Players" className="tab-menu" />
          <AntTab label="Accepted Players" className="tab-menu" />
        </AntTabs>
      </BoxHeader>

      <PlayerFilter
        currentTab={activeTab}
        selectedPlayer={selectedPlayer}
        setSelectedPlayer={setSelectedPlayer}
        selectedUser={selectedUser}
        setSelectedUser={setSelectedUser}
        startDate={startDate}
        setStartDate={setStartDate}
        endDate={endDate}
        setEndDate={setEndDate}
      />

      {activeTab === 0 && (
        <RejectedPlayer
          selectedPlayer={selectedPlayer}
          selectedRejectedBy={selectedUser}
          startDate={startDate}
          endDate={endDate}
        />
      )}

      {activeTab === 1 && (
        <AcceptedPlayer
          selectedPlayer={selectedPlayer}
          selectedAcceptedBy={selectedUser}
          startDate={startDate}
          endDate={endDate}
        />
      )}
    </AuthorizedLayout>
  );
}
